import { render, staticRenderFns } from "./Game6-4.vue?vue&type=template&id=a1456f1e&scoped=true&"
import script from "./Game6-4.vue?vue&type=script&lang=js&"
export * from "./Game6-4.vue?vue&type=script&lang=js&"
import style0 from "./Game6-4.vue?vue&type=style&index=0&id=a1456f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1456f1e",
  null
  
)

export default component.exports